/**
 * @generated SignedSource<<458d9893ac462800b76aefbe09a3bdcf>>
 * @relayHash 458b2902d36721f2228eeee5aa27d4b9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 103c2cd13d5f9e3cb11a1bf39be7b69e5dc64a1fdd05603c498133f13d11b37a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { DeferEditionModalComponentQuery } from './DeferEditionModalComponentQuery.graphql';

const node: PreloadableConcreteRequest<DeferEditionModalComponentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "103c2cd13d5f9e3cb11a1bf39be7b69e5dc64a1fdd05603c498133f13d11b37a",
    "metadata": {},
    "name": "DeferEditionModalComponentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
